import {AxiosError, HttpStatusCode} from 'axios'
import {ROUTES} from '@/utils/constants/routesConstants'

// Mock function for unauthorized error handling (replace with actual logic)
const onUnauthorisedError = async () => {
  console.warn('User unauthorized. Redirecting...')
  // window.location.href = '/'
}

export const handleNetworkErrors = async error => {
  const {code, response, message} = error
  const status = response?.status

  if (code === AxiosError.ERR_CANCELED) {
    return Promise.reject(new Error(message || 'Request was canceled'))
  }

  if (status === HttpStatusCode.Forbidden) {
    window.location.href = ROUTES.ERROR_403
  } else if (status === HttpStatusCode.Unauthorized || code === AxiosError.ERR_NETWORK) {
    try {
      await onUnauthorisedError()
    } catch (signOutError) {
      console.error('onUnauthorisedError::ERROR', signOutError)
    }
  }
  return Promise.reject(new Error(message || 'An error occurred'))
}

// Attach the interceptor to an Axios instance
export const attachErrorInterceptor = axiosInstance => {
  axiosInstance.interceptors.response.use(
    response => response, // Pass successful responses through
    handleNetworkErrors
  )
}
